import { createSlice } from '@reduxjs/toolkit';
import {
  IDLE_STATUS,
  SUCCESS_STATUS,
  LOADING_STATUS,
  ALTERNATIVE_LOADING_STATUS,
  FAILURE_STATUS,
} from '../status';
import {
  fetchAllAsync,
  fetchByIdAsync,
  fetchAsyncAtributosTratamentosTributarios,
} from './tratamentoTributarioThunks';
import i18n from '../../i18n';

const initialState = {
  status: IDLE_STATUS,
  error: null,
  response: {
    status: null,
    message: null,
    data: null,
  },
  list: [],
  isLoadingAtributos: false,
};

const tratamentoTributarioSlice = createSlice({
  name: 'tratamentoTributario',
  initialState,
  reducers: {
    changeStatusTo: (state, action) => {
      state.status = action.payload.status;
    },
    loading: (state) => {
      state.status = LOADING_STATUS;
    },
    success: (state) => {
      state.status = SUCCESS_STATUS;
    },
    failure: (state) => {
      state.status = FAILURE_STATUS;
    },
    resetStatus: (state) => {
      state.status = IDLE_STATUS;
    },
    setResponse: (state, action) => {
      state.response = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearResponse: (state) => {
      state.response = {
        status: null,
        message: null,
        data: null,
      };
    },
    setList: (state, action) => {
      state.list = action.payload || [];
    },
    resetList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAsync.pending, (state) => {
        state.status = ALTERNATIVE_LOADING_STATUS;
      })
      .addCase(fetchAllAsync.fulfilled, (state, action) => {
        state.status = IDLE_STATUS;
        state.list = action.payload.data;
      })
      .addCase(fetchAllAsync.rejected, (state, action) => {
        state.status = FAILURE_STATUS;
        state.error = {
          ...action.error,
          message: i18n.t('com.muralis.qcx.erro.carregarListaTratamentosTributarios', { erro: action.error.message }),
        };
      })
      .addCase(fetchByIdAsync.pending, (state) => {
        state.status = LOADING_STATUS;
      })
      .addCase(fetchByIdAsync.fulfilled, (state, action) => {
        if (action.payload.response.status === 200) {
          state.model = action.payload.response.data;
          state.status = SUCCESS_STATUS;
        }
      })
      .addCase(fetchByIdAsync.rejected, (state, action) => {
        state.status = FAILURE_STATUS;
        state.error = {
          ...action.error,
          message: i18n.t('com.muralis.qcx.erro.carregarDadosTratamentoTributario', { erro: action.error.message }),
        };
      })
      .addCase(fetchAsyncAtributosTratamentosTributarios.pending, (state) => {
        state.status = LOADING_STATUS;
        state.isLoadingAtributos = true;
      })
      .addCase(fetchAsyncAtributosTratamentosTributarios.fulfilled, (state, action) => {
        if (action.payload.response.status === 200) {
          state.model = action.payload.response.data;
          state.status = SUCCESS_STATUS;
          state.isLoadingAtributos = false;
        }
      })
      .addCase(fetchAsyncAtributosTratamentosTributarios.rejected, (state, action) => {
        state.status = FAILURE_STATUS;
        state.error = {
          ...action.error,
          message: i18n.t('com.muralis.qcx.erro.carregarDadosTratamentoTributario', { erro: action.error.message }),
        };
        state.isLoadingAtributos = false;
      });
  },
});

const {
  changeStatusTo,
  loading,
  success,
  failure,
  resetStatus,
  setResponse,
  setResponseMessage,
  clearResponse,
  setError,
  setList,
  resetList,
} = tratamentoTributarioSlice.actions;

const tratamentoTributarioActions = tratamentoTributarioSlice.actions;

export {
  tratamentoTributarioSlice,
  tratamentoTributarioActions,
  changeStatusTo,
  loading,
  success,
  failure,
  resetStatus,
  setResponse,
  setResponseMessage,
  clearResponse,
  setError,
  setList,
  resetList,
};

export default tratamentoTributarioSlice.reducer;
